import ProductIconByDeviceState from "./ProductIconByDeviceState"
import MapZoomByLevel from "./MapZoomByLevel"
import WeatherImgSourceByCN from "./WeatherImgSourceByCN"
import ColorByKey from "./ColorByKey"
import BadgeStatusByKey from "./BadgeStatusByKey"

export default {ProductIconByDeviceState, MapZoomByLevel, WeatherImgSourceByCN, ColorByKey, BadgeStatusByKey}